export default [
  {
    path: '/vehicleChecks/:id',
    name: 'vehicles-check-view',
    component: () => import('@/views/vehicle-check/vehicle-checks-view/VehicleCheckView'),
  },
]
